// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2-P4p","calendarButtons":"ClockData_calendarButtons__1Eobc"};